module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    on: {
      "click": _vm.handleClick
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f0deab62!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Button.vue
// module id = 169
// module chunks = 2